import axios from 'axios';
import * as types from '../constants/ActionTypes';
import { trackLink } from '../../lib/analytics-helper';
import Page from '../../lib/page';

const requestWebIvrAuthentication = () => ({ type: types.REQUEST_WEB_IVR_AUTHENTICATION });

const receiveWebIvrAuthenticationError = () => ({ type: types.RECEIVE_WEB_IVR_AUTHENTICATION_ERROR });

const receiveWebIvrAuthentication = (payload) => ({ type: types.RECEIVE_WEB_IVR_AUTHENTICATION, payload });

export default (options = {}) =>
  (dispatch) => {
    // we may expect (both or either of) webPin, csNumber
    dispatch(requestWebIvrAuthentication());
    const phoneURL = '/smarthelp/ivr-auth-web';

    return axios
      .post(phoneURL, { _csrf: document.body.getAttribute('data-token'), webMobileInfo: options })
      .then((response) => {
        const authStatus = ((response || {}).data || {}).success;
        trackLink({
          id: 'callPage',
          link: `webPinStepUpCSAuthApiSuccess|isMobile:${Page.isMobileLayout()}|isMobileauthwebStepupEnabledCountries:${Page.isMobileauthwebStepupEnabledCountries()}`,
        });
        dispatch(receiveWebIvrAuthentication(authStatus));
      })
      .catch(() => {
        trackLink({
          id: 'callPage',
          link: `webPinStepUpCSAuthApiError|isMobile:${Page.isMobileLayout()}|isMobileauthwebStepupEnabledCountries:${Page.isMobileauthwebStepupEnabledCountries()}`,
        });
        dispatch(receiveWebIvrAuthenticationError());
      });
  };
